export default () => ({
  languageList: [],
  status: undefined,
  setLanguageStatus: undefined,
  key: undefined,
  selectedLanguage: null,
});
